import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingRegions = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_REGION}`, "get");
    const body = await resp.json();

    debugLogActions(':: regionActions, startLoadingRegions', { 'body': body });

    if (body.ok) {

      dispatch(loadingRegions(body.regions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingRegions = (regions) => ({
  type: types.REGION_START_LOADING,
  payload: regions,
});

export const startLoadingRegionsPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_REGION}`, `get/${page}/${size}`);
    const body = await resp.json();

    debugLogActions(':: regionActions, startLoadingRegionsPaginated', { 'body': body });

    if (body.ok) {

      dispatch(loadingRegionsPaginated(body.regionPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingRegionsPaginated = (regionPaginated) => ({
  type: types.REGION_START_LOADING_PAGINATED,
  payload: regionPaginated,
});

export const selectRegions = (region) => ({
  type: types.REGION_SELECT,
  payload: region,
});

export const regionClean = () => ({
  type: types.REGION_CLEAN,
});

export const regionStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_REGION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

              debugLogActions(':: regionActions, regionStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(regionDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                  Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogRegionActions, regionStartDelete', { 'error': error });
    }
  };
};

const regionDeleted = (id) => {
  return {
    type: types.REGION_DELETE,
    payload: id,
  };
};

export const startSearchingRegionsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGION}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    debugLogActions(':: regionActions, startSearchingRegionPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingRegionsPaginated(body.regionsPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingRegionsPaginated = (regionsPaginated) => ({
  type: types.REGION_START_SEARCH_PAGINATED,
  payload: regionsPaginated,
});

export const cleanSearchingRegionsPaginated = () => ({
  type: types.REGION_CLEAN_SEARCH_PAGINATED,
});

export const regionStartUpdate = (region, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_REGION}`,
        `update/${region.id}`,
        region,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: regionActions, regionStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(regionUpdated(region));
        //Investigation
        //dispatch(cleanSearchingRegionsPaginated());
        //dispatch(regionCleanSearchText());

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-region");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogRegionActions, regionStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} region
 * @returns
 */
const regionUpdated = (region) => {
  return {
    type: types.REGION_UPDATE,
    payload: region,
  };
};

export const regionStartRegister = (region, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGION}`,
      "add",
      region,
      "POST"
    );

    const body = await resp.json();

    debugLogActions(':: regionActions, regionStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(regionRegister(body.region));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-region");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const regionRegister = (region) => ({
  type: types.REGION_START_REGISTER,
  payload: region,
});

export const regionSetSearchText = (searchText) => ({
  type: types.REGION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const regionCleanSearchText = () => ({
  type: types.REGION_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingRegionsAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_REGION}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingRegionAll(body.regions));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingRegionAll = (regions) => ({
  type: types.REGION_START_LOADING_ALL,
  payload: regions,
});
